import {AlertingAction} from "../../entities/AlertingAction";
import {Plugin} from "../../entities/Plugin";
import {AlertingActionService} from "../../services/AlertingActionService";
import {PluginService} from "../../services/PluginService";
import {NotificationService} from "../../services/NotificationService";
import {EditModel} from "./EditModel";

export class EditAlertingActionModel extends EditModel<AlertingAction> {
    $q:ng.IQService;
    entityId:number;
    plugins:SelectablePlugin[] = [];
    static $inject = ['$q','AlertingActionService','PluginService','NotificationService'];
    constructor($q:ng.IQService, public service:AlertingActionService, public pluginService:PluginService, public notifyService:NotificationService){
        super($q, service, AlertingAction);
    }
    loadData(entityId:number):ng.IPromise<boolean>{
      return super.loadData(entityId).then((ok)=> {
        return this.$q.all([this.pluginService.getAll()]).then((data)=>{
          var strPluginIds:string[] = this.entity.pluginActions != null ? this.entity.pluginActions.split(",") : [];
          var pluginIds:number[] = $.map(strPluginIds, (a,index)=>parseInt(a));
          var tempSelPlugin:SelectablePlugin[] = [];
          this.plugins = [];//.splice(0,this.plugins.length-1);
          for(var i=0;i<data[0].length;i++){
            var plugin = data[0][i];
            var foundMatch = $.grep(pluginIds, (tempItem, tempIndex)=>tempItem == plugin.id).length > 0;
            this.plugins.push(new SelectablePlugin(plugin,foundMatch));
          }
          return this.$q.when<boolean>(true);
        })
      });
    }
    verifyData():ng.IPromise<boolean> {
      if (this.entity.name == null || this.entity.name.length == 0) {
        this.notifyService.notifyError("Name is required.");
        return this.$q.when<boolean>(false);
      }
      return this.$q.when<boolean>(true);
    }
    saveData():ng.IPromise<boolean>{
      var pluginIds:number[] = [];
      for(var i=0;i<this.plugins.length; i++){
        var selPlugin:SelectablePlugin = this.plugins[i];
        if(selPlugin.isSelected == true)
          pluginIds.push(selPlugin.plugin.id);
      }
      this.entity.pluginActions = pluginIds.join();
      return super.saveData();
    }
}

export class SelectablePlugin{
    constructor(public plugin:Plugin, public isSelected:boolean = false){}
}
